<template>
  <div class="app-container app-page">
      <van-nav-bar :title="$t('setting.setting')" class="app-nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()"/>
        </template>
      </van-nav-bar>
      <div class="app-items">
        <div class="app-item" @click="toInfomation()">
          <div class="app-left">{{$t("setting.base_setting")}}</div>
          <van-icon name="arrow" />
        </div>
        <div class="app-item" @click="toLoginPassword()">
          <div class="app-left">{{$t("setting.login_pwd")}}</div>
          <van-icon name="arrow" />
        </div>
        <div class="app-item" @click="toPayPassword()">
          <div class="app-left">{{$t("setting.finance_pwd")}}</div>
          <div class="app-right">
            <span class="app-desc">{{this.userInfo.paypassword}}</span>
            <van-icon name="arrow" />
          </div>
        </div>
        <div class="app-item" @click="toLanguage()">
          <div class="app-left">{{$t("setting.language")}}</div>
          <div class="app-right">
            <van-icon name="arrow" />
          </div>
        </div>
      </div>
      <van-button class="app-sign-out" type="primary" size="normal" @click="loginout()">{{$t("setting.logout")}}</van-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    toPayPassword() {
      if(this.userInfo.paypassword !== this.$t("setting.no_setting") && this.$store.getters.getBaseInfo.edit_paypwd!==1){
        this.$toast(this.$t("withdraw.with_service"));
      } else {
        if (this.userInfo.paypassword) {
         this.$router.push({ path: '/account/security/payment-password/edit' });
        } else {
          this.$router.push({ path: '/account/security/payment-password/create' });
        }
      }
    },
    toLoginPassword(){
      this.$router.push({path:'/account/security/login-password'});
    },

    toLanguage(){
      this.$router.push({
        name:'account-settings-language',
        params: {
          "type": "setting"
        }
      });
    },
    toInfomation(){
      this.$router.push({path:'/account/profile'});
    },
    loginout(){
        localStorage.clear()
        this.$router.push({path:'/account'});
    },
    toServicePage(){
      this.$router.push("/support/page");
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          if(res.data.paypassword){
            this.userInfo.paypassword = this.$t("setting.y_setting");
          }else {
            this.userInfo.paypassword = this.$t("setting.no_setting");
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/auth/login'})
    }else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped src="./Setting.styles.less"></style>
